import { axiosApi } from '../axios';

export default {
  login: (user) => (
    axiosApi.post('/api/auth/login', user)
  ),
};
